module.exports = __webpack_public_path__ + "img/4-4.8dd64f6f.jpg";